import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { cart } from "@/theme/Cart";
import { ThemeComponent } from "@/theme/ThemeComponent";
import { CartMain } from "../Cart/CartMain";
import { SideCart } from '../SideCart/SideCart';

export interface SelectedProducts {
    id: number;
    quantity: number;
}

@Component
export class BundleProduct extends ThemeComponent {
    @Ref({required: false}) addToCart!: HTMLButtonElement;
    @Prop() bundleId!: number;

    protected loading: boolean = false;
    protected quantityVal: number = 1;
    private cartMain: CartMain = document.body.querySelector('cart-main') as CartMain;
    private sideCart: SideCart | null = document.body.querySelector('side-cart');

    /**
     * Initialise.
     */
    init() {
        this.$listen(this.addToCart, 'click', (event) => {
            event.preventDefault();
            this.addBundleToCart();
        });
    }

    protected addBundleToCart() {
        this.loading = true;
        const variant = this.bundleId;
        if (!variant) {
            this.showError(`Please select an option.`);
            return;
        }

        // const itemInCart:boolean = this.cartMain.checkCart(variant);
        cart.addItem({
            id: variant,
            quantity: this.quantityVal,
        }).then((item) => {
            // Dispatch event for other components to listen to
            document.dispatchEvent(new Event('cartChanged'));
        }).catch((event: unknown | null) => {
            if (event instanceof Error) {
                this.showError(event.message);
            }
        });

        this.loading = false;
    }

    protected showError(msg: string | null): void {
        // this.error.textContent = msg;
        // this.error.classList.add('is-active');
        // this.error.style.display = msg ? '' : 'none';
        // this.scrollIntoView();
    }
}
